import { useTourState, useTourStoreApi } from "@heroncendre/player";

/**
 * Le retour à l'accueil, un seul geste pour le bouton « Accueil » et le logo.
 *
 * Un parcours en cours s'arrête (sa voix ne doit pas continuer sous l'accueil), et la
 * visite revient à la scène d'entrée — celle sur laquelle l'accueil est posé : `startSceneId`,
 * à défaut la première scène. `onAccueil` change ensuite d'écran.
 */
export function useRetourAccueil(onAccueil: () => void): () => void {
  const store = useTourStoreApi();
  const tour = useTourState((state) => state.tour);

  return () => {
    store.getState().stopGuided();
    const entree = tour.settings.startSceneId ?? tour.scenes[0]?.id;
    if (entree && entree !== store.getState().currentSceneId) store.getState().goToScene(entree);
    onAccueil();
  };
}
